// The backend serialises pandas/NumPy values with Python's json.dumps, which
// emits bare NaN / Infinity tokens. Those are not valid JSON, so axios' own
// JSON.parse throws, and axios silently hands back the raw response string
// instead of the parsed object/array. Everything downstream then receives a
// String where it expects an Array.

// Quoted strings are matched first so they are consumed untouched; only bare
// NaN / Infinity value tokens are rewritten to null.
function nullifyNonFinite(text) {
  return text.replace(
    /"(?:\\.|[^"\\])*"|-?\bInfinity\b|\bNaN\b/g,
    (match) => (match.charAt(0) === '"' ? match : "null")
  );
}

// Returns the parsed payload, or null when the response cannot be parsed.
export function parseApiResponse(data) {
  if (typeof data !== "string") {
    return data;
  }
  try {
    return JSON.parse(nullifyNonFinite(data));
  } catch (e) {
    console.error("Unparseable API response", e);
    return null;
  }
}

// Convenience wrapper for the many endpoints that feed v-data-table items.
export function parseApiRows(data) {
  var payload = parseApiResponse(data);
  return Array.isArray(payload) ? payload : [];
}
